import type { SVGProps } from 'react';
const SvgHouse = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#house_svg__a)">
      <path
        fill="currentColor"
        d="M19 9.3V4h-3v2.6L12 3 2 12h3v8h5v-6h4v6h5v-8h3l-3-2.7Zm-9 .7c0-1.1.9-2 2-2s2 .9 2 2h-4Z"
      />
    </g>
    <defs>
      <clipPath id="house_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgHouse;
